import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {PURGE} from "redux-persist";
import {getColorWayDetail} from "../../../core/api/optionApis";

const initialState = {
  currentVehicle:"",
  currentNavigation : "",
  currentStep: "",
  currentHeader: "",
  isGnb:true,
  currentColorPicker:{},
  CONFIG_DATA:{
  },
  childNavigationData: "",
  dataSub: false,
  specialTypeColorList: [],
  interiorDetailPart: {
    "INT_KEY": [],
    "INT_SECONDARY": [],
    "INT_THIRD": []
  },
  dataDepth: "1"
}


export const loadDataAndSet = createAsyncThunk(
  'optionWindow/loadDataAndSet',
  async (payload, { getState }) => {
    const { processedData, colorway } = payload;
    const temp = { ...processedData };
    let currentInteriorDetailPart = {};

    const { currentVehicle } = getState().optionWindow;

    if (colorway && currentVehicle.id) {
      try {
        const res = await getColorWayDetail(currentVehicle.id, colorway);
        if (res.data.result && res.data.message === "SUCCESS") {
          const data = res.data.data;
          const colorGroup = {
            "INT_KEY": [],
            "INT_SECONDARY": [],
            "INT_THIRD": []
          }
          for (let group of data.colorwayGroups) {
            for (let colorTarget of group.colorwayItems) {
              colorGroup[group.groupName].push("INT_"+colorTarget);
            }
          }
          currentInteriorDetailPart = colorGroup;
        } else {
          console.error("Failed to fetch colorway details:", res.data.message);
        }
      } catch (error) {
        console.error("Error fetching colorway details:", error);
      }
    }


    currentInteriorDetailPart?.["INT_KEY"]?.forEach(item => {
      if (!temp[item]) {
        temp[item] = temp["INT_KEY"];
      }
    });

    const secondaryValue = temp["INT_SECONDARY"] || temp["INT_KEY"];
    currentInteriorDetailPart?.["INT_SECONDARY"]?.forEach(item => {

      if (!temp[item]) {
        temp[item] = secondaryValue;
      }
    });

    if (!temp["BACKGROUND"]) {
      temp["BACKGROUND"] = "DESERT";
    }

    return {
      CONFIG_DATA: temp,
      interiorDetailPart: currentInteriorDetailPart
    };
  }
);


export const optionWindowSlice = createSlice({
  name : "optionWindow",
  initialState : initialState,
  reducers : {
    clearOption(state){
      state = initialState
    },
    setCurrentVehicle(state,action) {
      state.currentVehicle = action.payload;
    },
    setInteriorDetailPart (state, action) {
      state.interiorDetailPart = action.payload;
    },
    setCurrentNavigation(state, action) {
      state.currentNavigation = action.payload;
    },
    setCurrentStep(state, action) {
      // if (state.currentStep === action.payload) {
      //   state.currentStep = "";
      // } else {
        state.currentStep = action.payload;
      // }

    },
    setCurrentHeader(state, action) {
      state.currentHeader = action.payload
    },
    setOptions(state,action){

      state[action.payload.selection] = action.payload.value
    },
    setConfigData(state, action) {
      state.CONFIG_DATA = action.payload;
    },
    setNotes(state, action) {
      const copyConfigData = {...state["CONFIG_DATA"]};
      const {key, value} = action.payload;
      const resultData = {...copyConfigData[key], ...value}

      if(!value.NOTES) {
        delete resultData.NOTES;
      }

      state["CONFIG_DATA"] = {
        ...copyConfigData,
        [key]: resultData
      }
    },
    setSendData(state, action) {
      const { key, value } = action.payload;
      if (!key) return;

      state.CONFIG_DATA[key] = value;

      if (key === "INT_KEY" || key === "INT_SECONDARY" || key === "INT_THIRD") {
        let detailsToUpdate = [];
        const colorway = state.CONFIG_DATA.COLORWAY;

        // COLORWAY가 없는 경우
        if (!colorway) {
          detailsToUpdate = [];
        }
        // SINGLE_COLOR로 변경: 모든 색상 초기화
        else if (key === "INT_KEY" && colorway === "SINGLE_COLOR") {
          state.CONFIG_DATA.INT_SECONDARY = "";
          state.CONFIG_DATA.INT_THIRD = "";
          detailsToUpdate = state.interiorDetailPart.INT_KEY;
        }
        // INT_KEY 변경 시 (SINGLE 제외): 빈 색상 자동 채우기 및 불필요한 색상 초기화
        else if (key === "INT_KEY") {
          if (state.CONFIG_DATA.INT_SECONDARY === "") {
            state.CONFIG_DATA.INT_SECONDARY = value;
          }
          if (colorway === "REAR_SEAT_HIGHLIGHT" && state.CONFIG_DATA.INT_THIRD === "") {
            state.CONFIG_DATA.INT_THIRD = value;
          }
          if ((colorway === "DUAL_COLOR" || colorway === "DUAL_COLOR_WITH_CONSOLE") && state.CONFIG_DATA.INT_THIRD !== "") {
            state.CONFIG_DATA.INT_THIRD = "";
          }
          detailsToUpdate = state.interiorDetailPart[key];
        }
        // 그 외: 해당 키의 파트만 업데이트
        else {
          detailsToUpdate = state.interiorDetailPart[key];
        }

        detailsToUpdate?.forEach((detail) => {
          state.CONFIG_DATA[detail] = value;
        });
      }
    },
    setSendDataRemove(state,action){
      const copyConfigData = {...state["CONFIG_DATA"]};
      delete copyConfigData[action.payload];
      state["CONFIG_DATA"] = copyConfigData;
    },
    setSelectedColorPicker(state,action){
      state.currentColorPicker = {
        ...state.currentColorPicker,
        [action.payload.key]:action.payload.value
      }
    },
    setClearOption(state){
      const keys = Object.keys(state);
      for(var i = 0;  i< keys.length;i++){
        const key = keys[i]
        if(key !== "allColorTypeData" && key !== "currentVehicle"){

          delete state[key]
        }
      }

      const initkeys = Object.keys(initialState);
      for(var i = 0;  i< initkeys.length;i++){
        const key = initkeys[i]
        if(key !== "allColorTypeData" && key !== "currentVehicle"){

          state[key] = initialState[key]
        }
      }
    },

    setChildNavigationData(state, action) {
      state.childNavigationData = action.payload;
    },
    setDataSub(state, action) {
      state.dataSub = action.payload;
    },
    setDataDepth(state, action) {
      state.dataDepth = action.payload;
    },
    setSpecialTypeColorList (state, action) {
      state.specialTypeColorList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
    builder.addCase(loadDataAndSet.fulfilled, (state, action) => {
      state.CONFIG_DATA = action.payload.CONFIG_DATA;
      state.interiorDetailPart = action.payload.interiorDetailPart;
    });
    builder.addCase(loadDataAndSet.rejected, (state, action) => {
      console.error("Failed to load data and set config:", action.error);
    });
  }
})



export const optionAction = optionWindowSlice.actions;
